import React from 'react';
import cx from 'classnames';

import styles from './Spacer.module.scss';

enum SpacerSize {
	Large = 'large',
	Medium = 'medium',
	Small = 'small',
	Xsmall = 'xsmall',
}

interface SpaceProps {
	size?: `${SpacerSize}`;
}

const Spacer: React.FC<SpaceProps> = ({ size = SpacerSize.Medium, ...props }) => (
	<hr {...props} className={cx(styles.horizontalRule, styles[size])} />
);

export default Spacer;
